import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { ClassifyAndEnforceModal } from '../components/ClassifyAndEnforceModal/ClassifyAndEnforceModal';
import { EnforceViolationModal } from '../components/EnforceViolationModal/EnforceViolationModal';
import { ViolationReviewModal } from '../components/ViolationReviewModal/ViolationReviewModal';
import { ViolationTypeFormModal } from '../components/ViolationTypeFormModal/ViolationTypeFormModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const VIOLATION_MODALS = {
  REVIEW: 'violations.review-case',
  ENFORCE: 'violations.enforce',
  CLASSIFY: 'violations.classify-and-enforce',
  TYPE_FORM: 'violations.type-form',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * **Two confirmation dialogs, not one with a branch.** `POST /enforce` takes an
 * optional `violationTypeId` that is *required* for exactly the rows the
 * classifier could not judge and ignored for every other one — so a single
 * dialog would carry a field that is mandatory or meaningless depending on a
 * property of the row, which is precisely the shape that produces a 422 nobody
 * predicted. Two types make the mistake unrepresentable: `ENFORCE` never sends
 * the key, `CLASSIFY` always does, and the queue chooses between them on
 * `violationTypeKey === null`.
 *
 * **The review dialog hosts them rather than replacing itself.** It opens on top
 * (`DialogStack`), and when it closes the case underneath has already re-read
 * itself through the shared tag — so the moderator sees the outcome of what they
 * just confirmed instead of an empty screen.
 *
 * Every surface opens these by **string**, so no list imports the component that
 * writes a consequence (W2), and the payload is an **id** alone — `ModalData` is
 * serializable-only and each dialog reads the rest from its own query.
 */
export const violationsModals: readonly ModalRegistration[] = [
  { modalTypes: [VIOLATION_MODALS.REVIEW], component: ViolationReviewModal },
  { modalTypes: [VIOLATION_MODALS.ENFORCE], component: EnforceViolationModal },
  { modalTypes: [VIOLATION_MODALS.CLASSIFY], component: ClassifyAndEnforceModal },
  { modalTypes: [VIOLATION_MODALS.TYPE_FORM], component: ViolationTypeFormModal },
];
